import { legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import { hasActiveCancellableActionProgress } from '../../../store/selectors/actionProgress';
import { hasPendingOperations } from '../../../store/selectors/operationProgress';

import OperationProgressNotification from './OperationProgressNotification';

export default connect((store: AppState) => ({
  pending:
    hasPendingOperations(store) && !hasActiveCancellableActionProgress(store),
}))(OperationProgressNotification);
